export default [
    {
        "fakeSha": "cce9b7eb",
        "date": "2013-04-04",
        "message": "Check in node_modules to prevent doom and gloom",
        "stats": {
            "additions": 553514,
            "deletions": 2
        }
    },
    {
        "fakeSha": "a69fd501",
        "date": "2013-04-09",
        "message": "Packaging is hard you guys",
        "stats": {
            "additions": 7,
            "deletions": 8
        }
    },
    {
        "fakeSha": "4de95e97",
        "date": "2013-04-09",
        "message": "Oops fix all the debian things",
        "stats": {
            "additions": 2,
            "deletions": 2
        }
    },
    {
        "fakeSha": "b9a38e3a",
        "date": "2013-04-18",
        "message": "More TypeError fixes O GAWD HOYER HALP",
        "stats": {
            "additions": 1,
            "deletions": 1
        }
    },
    {
        "fakeSha": "624c40a7",
        "date": "2013-05-16",
        "message": "Ummm I am bad at sed",
        "stats": {
            "additions": 2,
            "deletions": 2
        }
    },
    {
        "fakeSha": "a31c26c8",
        "date": "2013-05-16",
        "message": "HOW TO DEBIAN",
        "stats": {
            "additions": 5,
            "deletions": 5
        }
    },
    {
        "fakeSha": "21f55136",
        "date": "2013-05-16",
        "message": "Stop doing fancy unix tricks and just read a versions.json.in file.",
        "stats": {
            "additions": 11,
            "deletions": 10
        }
    },
    {
        "fakeSha": "e43a644f",
        "date": "2013-05-21",
        "message": "No semicolons in objects noob",
        "stats": {
            "additions": 2,
            "deletions": 2
        }
    },
    {
        "fakeSha": "a10fb509",
        "date": "2013-05-21",
        "message": "Fix teh nits",
        "stats": {
            "additions": 11,
            "deletions": 6
        }
    },
    {
        "fakeSha": "aa7d4c06",
        "date": "2013-10-02",
        "message": "Prelim STREAMING ATC DEPLOYMENT YEAAAAH",
        "stats": {
            "additions": 34,
            "deletions": 14
        }
    },
    {
        "fakeSha": "06bf6f9f",
        "date": "2013-10-02",
        "message": "Socket.iooooooo",
        "stats": {
            "additions": 212725,
            "deletions": 1
        }
    },
    {
        "fakeSha": "408b7ee9",
        "date": "2013-10-16",
        "message": "Commas before things are for chumps",
        "stats": {
            "additions": 2,
            "deletions": 2
        }
    },
    {
        "fakeSha": "c0977edb",
        "date": "2013-10-16",
        "message": "NEVER LET ME NEAR CODE EVER",
        "stats": {
            "additions": 1,
            "deletions": 0
        }
    },
    {
        "fakeSha": "d9680c29",
        "date": "2013-12-18",
        "message": "OKAY FINE LOVETT JEEZ",
        "stats": {
            "additions": 3,
            "deletions": 3
        }
    },
    {
        "fakeSha": "090c1a25",
        "date": "2013-12-18",
        "message": "Q also",
        "stats": {
            "additions": 3,
            "deletions": 3
        }
    },
    {
        "fakeSha": "839184d5",
        "date": "2013-12-18",
        "message": "Stop checking in node_modules",
        "stats": {
            "additions": 0,
            "deletions": 821232
        }
    },
    {
        "fakeSha": "5fe8874b",
        "date": "2013-12-18",
        "message": "Ignore node modules if you have them yo",
        "stats": {
            "additions": 1,
            "deletions": 0
        }
    },
    {
        "fakeSha": "23e24a2c",
        "date": "2013-12-18",
        "message": "lol jk",
        "stats": {
            "additions": 2,
            "deletions": 1
        }
    },
    {
        "fakeSha": "d5034539",
        "date": "2013-12-18",
        "message": "LOL OKAY YOU GET TABS OKAY",
        "stats": {
            "additions": 1,
            "deletions": 2
        }
    },
    {
        "fakeSha": "ff8ad315",
        "date": "2013-12-18",
        "message": "Dot dot slash",
        "stats": {
            "additions": 2,
            "deletions": 2
        }
    },
    {
        "fakeSha": "9e361f7d",
        "date": "2013-12-18",
        "message": "Pwd why not",
        "stats": {
            "additions": 2,
            "deletions": 0
        }
    },
    {
        "fakeSha": "03d39833",
        "date": "2013-12-18",
        "message": "Dot slash node modules",
        "stats": {
            "additions": 2,
            "deletions": 2
        }
    },
    {
        "fakeSha": "033f35c1",
        "date": "2013-12-18",
        "message": "FUCK YOU DEBIAN FUCK",
        "stats": {
            "additions": 3,
            "deletions": 0
        }
    },
    {
        "fakeSha": "91285c96",
        "date": "2013-12-18",
        "message": "SOURCE BRO",
        "stats": {
            "additions": 1,
            "deletions": 2
        }
    },
    {
        "fakeSha": "818dc89e",
        "date": "2013-12-18",
        "message": "Do that guys",
        "stats": {
            "additions": 1,
            "deletions": 1
        }
    },
    {
        "fakeSha": "4c60a096",
        "date": "2013-12-18",
        "message": "Whatever the thing is that you said",
        "stats": {
            "additions": 1,
            "deletions": 3
        }
    },
    {
        "fakeSha": "d18696c8",
        "date": "2013-12-18",
        "message": "HOYER UNDERSTANDS THIS ONE",
        "stats": {
            "additions": 2,
            "deletions": 2
        }
    }
];



// WEBPACK FOOTER //
// ./src/data/aashay-commits.js